import { FC } from 'react';
import { useBreakpoint, GenericLink, NextgenImage } from '@nextgen-web-framework/all';
import type { SiteLogos, SiteLogoProps } from './types/propsTypes';
import styles from './SiteLogo.module.scss';

const SiteLogo: FC<SiteLogos> = ({ logos }) => {
  const viewPortType = useBreakpoint();

  const logo = logos && (logos.find((logo) => logo.viewport.includes(viewPortType)) || logos[0]);
  return (
    <>
      <GenericLink forceNative={false} href={'/'} data-testid="siteLogo-test-id">
        <div className={styles['site-logo']}>
          <div className={styles['site-logo-container']}>
            <NextgenImage src={logo?.url} alt={logo?.alt_text} />
          </div>
        </div>
      </GenericLink>
    </>
  );
};

export default SiteLogo;
export type { SiteLogos, SiteLogoProps };
